(() => {
   const STYLE_ID = "custom-disable-checkout";
    document.addEventListener("DOMContentLoaded", e => {
      document.querySelector("cart-form#AjaxCartForm").addEventListener("cart-updated", function() {
        if (!document.getElementById(STYLE_ID)) {
          const style = document.createElement("style");
          style.innerHTML = `
            #CheckOut {
              opacity: 0.6 !important;
              pointer-events: none !important;
            }
          `;
          style.id = STYLE_ID;
          document.head.appendChild(style);
      
        setTimeout(() => {
          const existingStyle = document.getElementById(STYLE_ID);
          if (existingStyle) {
            existingStyle.remove();
          }
        }, 1000);
        }

        BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.()
      })
    })
  setTimeout(() => {
    document.querySelector("#custom-hide-payment")?.remove?.();
  }, 1000)
})()
